import GlobalMessageBoard from "./GlobalMessageBoard";
export default GlobalMessageBoard;



// WEBPACK FOOTER //
// ./components/common/global-message-board/index.js